module.exports = __webpack_public_path__ + "img/tool_circle_small.090b8c98.svg";